const global = window

inputs.types.paletteGrid = function (data, name, niceName, type, input, parent, inputWindow) {
    const textarea = input;
    const wrapper = parent.find('.palette-grid-wrapper');
    const container = wrapper.find('.palette-grid-container');

    const defaultColor = '#ffffff';

    // Returns rgba(...) when alpha < 1, hex otherwise
    const colorToString = (colorObj) => {
        if (!colorObj) return defaultColor;
        const alpha = colorObj.getAlpha();
        if (alpha < 1) {
            return colorObj.toRgbString(); // e.g. rgba(202, 43, 43, 0.504)
        }
        return colorObj.toHexString(); // e.g. #ca2b2b
    };
    let currentPalette = [];

    // Cache of all colors ever assigned/loaded (to preserve colors when shrinking and re-expanding)
    let paletteCache = {};
    let isResizing = false;

    const savePalette = () => {
        textarea.val(JSON.stringify(currentPalette));
        textarea.trigger('change');
    };

    const loadPaletteFromTextarea = () => {
        let val = textarea.val();
        if (val) {
            try {
                let parsed = JSON.parse(val);
                if (Array.isArray(parsed) && parsed.length) {
                    if (!Array.isArray(parsed[0])) {
                        currentPalette = [parsed];
                    } else {
                        currentPalette = parsed;
                    }
                    // Populate cache with loaded colors
                    for (let r = 0; r < currentPalette.length; r++) {
                        for (let c = 0; c < currentPalette[r].length; c++) {
                            paletteCache[`${r},${c}`] = currentPalette[r][c];
                        }
                    }
                }
            } catch (e) {}
        }
    };

    // ---- Render Grid Cells ----
    const renderGrid = () => {
        container.empty();

        const numRows = currentPalette.length;
        const numCols = currentPalette[0] ? currentPalette[0].length : 0;

        container.css({
            'grid-template-columns': `repeat(${numCols}, 32px)`,
            'width': 'fit-content'
        });

        let dragSrc = null;

        for (let r = 0; r < numRows; r++) {
            for (let c = 0; c < numCols; c++) {
                const color = currentPalette[r][c] || defaultColor;
                const cell = $('<div class="palette-grid-cell"></div>')
                    .attr('data-row', r)
                    .attr('data-col', c)
                    .css('background-color', color);

                const colorInput = $('<input type="text" tabindex="-1" style="opacity:0;position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;" />');
                cell.append(colorInput);
                container.append(cell);

                // PERFORMANCE OPTIMIZATION: Do not initialize spectrum during active resize dragging
                if (!isResizing && typeof $.fn.spectrum !== 'undefined') {
                    colorInput.spectrum({
                        preferredFormat: 'hex',
                        color: color,
                        showAlpha: true,
                        showPalette: false,
                        showButtons: false,
                        showInput: true,
                        move: (colorObj) => {
                            const newColor = colorToString(colorObj);
                            updateColor(r, c, newColor, cell);
                        },
                        change: (colorObj) => {
                            const newColor = colorToString(colorObj);
                            updateColor(r, c, newColor, cell);
                        }
                    });
                }

                // Click opens spectrum
                let didDrag = false;
                cell[0].addEventListener('mousedown', () => { didDrag = false; });
                cell[0].addEventListener('dragstart', () => { didDrag = true; });

                cell.on('click', function (e) {
                    if (didDrag) { didDrag = false; return; }
                    if (!isResizing && typeof $.fn.spectrum !== 'undefined') {
                        colorInput.spectrum('show');
                    }
                    e.preventDefault();
                });

                // Drag & Drop
                cell.attr('draggable', 'true');

                cell[0].addEventListener('dragstart', (e) => {
                    dragSrc = { row: r, col: c };
                    cell.addClass('drag-source');
                    e.dataTransfer.effectAllowed = 'move';
                    e.dataTransfer.setData('text/plain', `${r},${c}`);
                });

                cell[0].addEventListener('dragend', () => {
                    cell.removeClass('drag-source');
                    container.find('.drag-over-swap, .drag-over-slide').removeClass('drag-over-swap drag-over-slide');
                });

                cell[0].addEventListener('dragover', (e) => {
                    e.preventDefault();
                    if (!dragSrc) return;
                    if (dragSrc.row === r && dragSrc.col === c) return;
                    e.dataTransfer.dropEffect = 'move';

                    container.find('.drag-over-swap, .drag-over-slide').removeClass('drag-over-swap drag-over-slide');
                    if (e.shiftKey) {
                        cell.addClass('drag-over-slide');
                    } else {
                        cell.addClass('drag-over-swap');
                    }
                });

                cell[0].addEventListener('dragleave', () => {
                    cell.removeClass('drag-over-swap drag-over-slide');
                });

                cell[0].addEventListener('drop', (e) => {
                    e.preventDefault();
                    cell.removeClass('drag-over-swap drag-over-slide');
                    if (!dragSrc) return;
                    if (dragSrc.row === r && dragSrc.col === c) return;

                    const srcIdx = dragSrc.row * numCols + dragSrc.col;
                    const destIdx = r * numCols + c;

                    // Flatten
                    let flat = [];
                    for (let rowIdx = 0; rowIdx < numRows; rowIdx++) {
                        for (let colIdx = 0; colIdx < numCols; colIdx++) {
                            flat.push(currentPalette[rowIdx][colIdx] || defaultColor);
                        }
                    }

                    if (e.shiftKey) {
                        // Slide mode
                        const [removed] = flat.splice(srcIdx, 1);
                        flat.splice(destIdx, 0, removed);
                    } else {
                        // Swap mode
                        const tmp = flat[srcIdx];
                        flat[srcIdx] = flat[destIdx];
                        flat[destIdx] = tmp;
                    }

                    // Restore to 2D
                    for (let rowIdx = 0; rowIdx < numRows; rowIdx++) {
                        currentPalette[rowIdx] = flat.slice(rowIdx * numCols, rowIdx * numCols + numCols);
                        // Update cache as well
                        for (let colIdx = 0; colIdx < numCols; colIdx++) {
                            paletteCache[`${rowIdx},${colIdx}`] = currentPalette[rowIdx][colIdx];
                        }
                    }

                    renderGrid();
                    savePalette();
                    dragSrc = null;
                });
            }
        }
    };

    const updateColor = (row, col, newColor, cell) => {
        cell.css('background-color', newColor);
        if (!currentPalette[row]) currentPalette[row] = [];
        currentPalette[row][col] = newColor;
        paletteCache[`${row},${col}`] = newColor;
        savePalette();
    };

    // ---- Resize Handlers ----
    const initResize = () => {
        const step = 36; // 32px cell + 4px gap

        const startResize = (e, axis) => {
            e.preventDefault();
            e.stopPropagation();

            isResizing = true;

            const startX = e.clientX;
            const startY = e.clientY;
            const startRows = currentPalette.length;
            const startCols = currentPalette[0] ? currentPalette[0].length : 0;

            const onMouseMove = (moveEvent) => {
                const dx = moveEvent.clientX - startX;
                const dy = moveEvent.clientY - startY;

                let newCols = startCols;
                let newRows = startRows;

                if (axis === 'r' || axis === 'br') {
                    newCols = Math.max(1, startCols + Math.round(dx / step));
                }
                if (axis === 'b' || axis === 'br') {
                    newRows = Math.max(1, startRows + Math.round(dy / step));
                }

                if (newCols !== (currentPalette[0] ? currentPalette[0].length : 0) || newRows !== currentPalette.length) {
                    resizePalette(newRows, newCols);
                }
            };

            const onMouseUp = () => {
                isResizing = false;
                $(document).off('mousemove', onMouseMove);
                $(document).off('mouseup', onMouseUp);

                // Fully render grid one final time to initialize spectrum picker on all current cells
                renderGrid();
                savePalette();
            };

            $(document).on('mousemove', onMouseMove);
            $(document).on('mouseup', onMouseUp);
        };

        wrapper.find('.palette-resize-handle-r').on('mousedown', (e) => startResize(e, 'r'));
        wrapper.find('.palette-resize-handle-b').on('mousedown', (e) => startResize(e, 'b'));
        wrapper.find('.palette-resize-handle-br').on('mousedown', (e) => startResize(e, 'br'));
    };

    const resizePalette = (newRows, newCols) => {
        let newPalette = [];
        for (let r = 0; r < newRows; r++) {
            let row = [];
            for (let c = 0; c < newCols; c++) {
                // Restore from cache if color was previously registered there, otherwise defaultColor
                const cachedColor = paletteCache[`${r},${c}`];
                row.push(cachedColor || defaultColor);
            }
            newPalette.push(row);
        }
        currentPalette = newPalette;
        renderGrid();
    };

    // ---- Initial Load ----
    loadPaletteFromTextarea();
    renderGrid();
    initResize();

    textarea.change(function () {
        if (!isResizing) {
            loadPaletteFromTextarea();
            renderGrid();
        }
    });

    return data;
};
